// Mock data for BiteSite website

export const translations = {
  en: {
    nav: {
      services: "Services",
      why: "Why Me",
      process: "Process",
      portfolio: "Example Sites",
      contact: "Contact"
    },
    hero: {
      headline: "Modern Websites for Hotels",
      subtext: "Build your perfect website now",
      cta: "Build Your Site"
    },
    services: {
      title: "What I Offer",
      subtitle: "Custom solutions tailored to your hotel's needs",
      items: [
        {
          title: "Hotel Website Design",
          description: "Beautiful, fast-loading websites that showcase your hotel's unique atmosphere and amenities."
        },
        {
          title: "Online Booking Integration",
          description: "Seamless booking systems that work perfectly on all devices and integrate with your reservation platform."
        },
        {
          title: "Mobile-First Design",
          description: "Your guests browse on their phones. Your website will look stunning on every screen size."
        },
        {
          title: "Contact & Reservation Setup",
          description: "Make it easy for guests to reach you or book a room with integrated contact and reservation forms."
        },
        {
          title: "Google Maps Integration",
          description: "Help guests find you easily with embedded maps and clear directions to your location."
        },
        {
          title: "Basic SEO",
          description: "Get found on Google when people search for hotels in your area with SEO best practices."
        }
      ],
      customNote: "Custom requests welcome – tell me what you need!"
    },
    why: {
      title: "Why Choose BiteSite",
      subtitle: "Direct communication, fast delivery, hotel-focused expertise",
      items: [
        {
          title: "Simple Process",
          description: "No complicated agency workflows. Just you, me, and building your perfect website."
        },
        {
          title: "Fast Delivery",
          description: "Get your hotel online quickly without sacrificing quality or attention to detail."
        },
        {
          title: "Hotel Expertise",
          description: "I specialize in hotels. I understand your needs, your guests, and what works."
        },
        {
          title: "Direct Communication",
          description: "Work directly with me – no middlemen, no miscommunication, just clear collaboration."
        }
      ]
    },
    process: {
      title: "How It Works",
      subtitle: "Four simple steps from idea to launch",
      steps: [
        {
          number: "01",
          title: "Contact",
          description: "Tell me about your hotel and what you need. We'll discuss your vision and requirements."
        },
        {
          number: "02",
          title: "Design",
          description: "I'll create a design that matches your hotel's style and attracts your ideal guests."
        },
        {
          number: "03",
          title: "Build",
          description: "I develop your website with clean code, fast performance, and mobile-first approach."
        },
        {
          number: "04",
          title: "Launch",
          description: "Your website goes live. I'll help you get started and ensure everything works perfectly."
        }
      ]
    },
    contact: {
      title: "Let's Build Your Site",
      subtitle: "Get in touch to discuss your hotel's new website",
      form: {
        name: "Your Name",
        hotelName: "Hotel Name",
        email: "Email",
        message: "Tell me about your project",
        specialRequests: "Special Requests (optional)",
        submit: "Send Message",
        sending: "Sending...",
        success: "Message sent! I'll get back to you soon.",
        namePlaceholder: "John Doe",
        hotelPlaceholder: "Grand Palace Hotel",
        emailPlaceholder: "you@hotel.com",
        messagePlaceholder: "I need a website for my hotel...",
        specialRequestsPlaceholder: "Online booking, multilingual, etc.",
        validation: {
          required: "Please fill out this field",
          email: "Please enter a valid email address"
        }
      },
      info: {
        email: "ErikmAndersen@proton.me",
        phone: "+41 79 812 19 11",
        location: "Geneva, Switzerland",
        phoneLabel: "Phone / WhatsApp",
        locationLabel: "Location"
      },
      bio: {
        name: "Erik M. Andersen",
        text: "I'm based in Geneva and work with hotels across Switzerland. Whether you're a luxury resort, boutique hotel, or cozy bed & breakfast, I'll create a website that works for you."
      }
    },
    footer: {
      tagline: "Modern websites for hotels in Geneva",
      rights: "All rights reserved"
    },
    portfolio: {
      title: "Example Sites",
      subtitle: "See examples of non-functioning sites to show you what I can do",
      disclaimer: "* Example websites for demonstration purposes",
      sites: {
        alpineRetreat: {
          type: "Mountain Resort",
          description: "Luxury alpine escape with stunning views"
        },
        lakeviewManor: {
          type: "Lakeside Hotel",
          description: "Elegant lakefront accommodations"
        },
        urbanSuites: {
          type: "City Boutique Hotel",
          description: "Modern comfort in the heart of the city"
        },
        chateauBelleville: {
          type: "Historic Hotel",
          description: "Timeless elegance in a heritage setting"
        },
        zenRetreat: {
          type: "Wellness Spa Hotel",
          description: "Tranquil sanctuary for mind and body"
        }
      }
    },
    messageReceived: {
      title: "Message Received!",
      subtitle: "Thanks for reaching out to BiteSite. We have received your request and will get back to you within 24 hours.",
      buttonText: "Back to Home",
      needHelp: "Need immediate assistance?",
      emailUs: "Email us directly",
      orCall: "or call"
    }
  },
  fr: {
    nav: {
      services: "Services",
      why: "Pourquoi Moi",
      process: "Processus",
      portfolio: "Sites Exemples",
      contact: "Contact"
    },
    hero: {
      headline: "Sites Web Modernes pour Hôtels",
      subtext: "Construisez votre site web parfait maintenant",
      cta: "Créez Votre Site"
    },
    services: {
      title: "Ce Que J'offre",
      subtitle: "Solutions sur mesure adaptées aux besoins de votre hôtel",
      items: [
        {
          title: "Conception de Site Web Hôtelier",
          description: "Des sites web magnifiques et rapides qui mettent en valeur l'atmosphère unique et les équipements de votre hôtel."
        },
        {
          title: "Intégration Réservation en Ligne",
          description: "Systèmes de réservation fluides qui fonctionnent parfaitement sur tous les appareils."
        },
        {
          title: "Design Mobile-First",
          description: "Vos clients naviguent sur leurs téléphones. Votre site sera superbe sur toutes les tailles d'écran."
        },
        {
          title: "Configuration Contact & Réservation",
          description: "Facilitez la prise de contact ou la réservation d'une chambre avec des formulaires intégrés."
        },
        {
          title: "Intégration Google Maps",
          description: "Aidez les clients à vous trouver facilement avec des cartes intégrées et des directions claires."
        },
        {
          title: "SEO de Base",
          description: "Soyez trouvé sur Google lorsque les gens recherchent des hôtels dans votre région."
        }
      ],
      customNote: "Demandes personnalisées bienvenues – dites-moi ce dont vous avez besoin !"
    },
    why: {
      title: "Pourquoi Choisir BiteSite",
      subtitle: "Communication directe, livraison rapide, expertise hôtelière",
      items: [
        {
          title: "Processus Simple",
          description: "Pas de workflows d'agence compliqués. Juste vous, moi, et la création de votre site parfait."
        },
        {
          title: "Livraison Rapide",
          description: "Mettez votre hôtel en ligne rapidement sans sacrifier la qualité ou l'attention aux détails."
        },
        {
          title: "Expertise Hôtelière",
          description: "Je me spécialise dans les hôtels. Je comprends vos besoins, vos clients et ce qui fonctionne."
        },
        {
          title: "Communication Directe",
          description: "Travaillez directement avec moi – pas d'intermédiaires, pas de malentendus, juste une collaboration claire."
        }
      ]
    },
    process: {
      title: "Comment Ça Marche",
      subtitle: "Quatre étapes simples de l'idée au lancement",
      steps: [
        {
          number: "01",
          title: "Contact",
          description: "Parlez-moi de votre hôtel et de vos besoins. Nous discuterons de votre vision."
        },
        {
          number: "02",
          title: "Design",
          description: "Je créerai un design qui correspond au style de votre hôtel et attire vos clients idéaux."
        },
        {
          number: "03",
          title: "Construction",
          description: "Je développe votre site web avec un code propre, des performances rapides et une approche mobile-first."
        },
        {
          number: "04",
          title: "Lancement",
          description: "Votre site web est mis en ligne. Je vous aiderai à démarrer et m'assurerai que tout fonctionne parfaitement."
        }
      ]
    },
    contact: {
      title: "Créons Votre Site",
      subtitle: "Contactez-moi pour discuter du nouveau site web de votre hôtel",
      form: {
        name: "Votre Nom",
        hotelName: "Nom de l'Hôtel",
        email: "Email",
        message: "Parlez-moi de votre projet",
        specialRequests: "Demandes Spéciales (optionnel)",
        submit: "Envoyer le Message",
        sending: "Envoi en cours...",
        success: "Message envoyé ! Je vous répondrai bientôt.",
        namePlaceholder: "Jean Dupont",
        hotelPlaceholder: "Grand Palace Hôtel",
        emailPlaceholder: "vous@hotel.com",
        messagePlaceholder: "J'ai besoin d'un site web pour mon hôtel...",
        specialRequestsPlaceholder: "Réservation en ligne, multilingue, etc.",
        validation: {
          required: "Veuillez remplir ce champ",
          email: "Veuillez entrer une adresse email valide"
        }
      },
      info: {
        email: "ErikmAndersen@proton.me",
        phone: "+41 79 812 19 11",
        location: "Genève, Suisse",
        phoneLabel: "Téléphone / WhatsApp",
        locationLabel: "Localisation"
      },
      bio: {
        name: "Erik M. Andersen",
        text: "Je suis basé à Genève et je travaille avec des hôtels à travers la Suisse. Que vous soyez un resort de luxe, un hôtel boutique ou un bed & breakfast chaleureux, je créerai un site web qui vous convient."
      }
    },
    footer: {
      tagline: "Sites web modernes pour hôtels à Genève",
      rights: "Tous droits réservés"
    },
    portfolio: {
      title: "Sites Exemples",
      subtitle: "Découvrez des exemples de sites non fonctionnels pour vous montrer ce que je peux faire",
      disclaimer: "* Sites web d'exemple à des fins de démonstration",
      sites: {
        alpineRetreat: {
          type: "Resort de Montagne",
          description: "Évasion alpine de luxe avec vues imprenables"
        },
        lakeviewManor: {
          type: "Hôtel au Bord du Lac",
          description: "Hébergement élégant au bord du lac"
        },
        urbanSuites: {
          type: "Hôtel Boutique Urbain",
          description: "Confort moderne au cœur de la ville"
        },
        chateauBelleville: {
          type: "Hôtel Historique",
          description: "Élégance intemporelle dans un cadre patrimonial"
        },
        zenRetreat: {
          type: "Hôtel Spa & Bien-être",
          description: "Sanctuaire de tranquillité pour le corps et l'esprit"
        }
      }
    },
    messageReceived: {
      title: "Message Reçu!",
      subtitle: "Merci de nous avoir contacté. Nous avons reçu votre demande et vous répondrons dans les 24 heures.",
      buttonText: "Retour à l'Accueil",
      needHelp: "Besoin d'aide immédiate?",
      emailUs: "Envoyez-nous un email",
      orCall: "ou appelez"
    }
  }
};

// Mock form submission handler
export const submitContactForm = (formData) => {
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log('Mock form submission:', formData);
      resolve({ success: true });
    }, 1000);
  });
};
